import React from "react";
import {
  Typography,
  Button,
  Box,
  SvgIcon,
  List,
  ListItem,
  ButtonBase,
  Badge,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ProductModal from "./productOrderModal";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import InputLocation from "./inputs/PlacesAutocomplete";
import AddressDisplay from "./addressDisplay";
import { Link } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import CloseIcon from "@mui/icons-material/Close";
import { CatalogContext } from "../context/catalogContext";
import { useOrder } from "../context/orderContext";

const addThousandsSeparator = (x) => x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") || 0;

const Menu = () => {
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const [modalMode, setModalMode] = React.useState();
  const [selectedProduct, setSelectedProduct] = React.useState();
  const [addressModal, setAddressModal] = React.useState(false);
  const [clientLocation, setClientLocation] = React.useState();
  const catalog = React.useContext(CatalogContext);
  const { order, setOrder } = useOrder();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box display="flex" justifyContent="center" mb={2} px={isMobile ? 2 : 4}>
        <Button
          sx={{ fontWeight: "bold" }}
          color="primary"
          variant="outlined"
          size="large"
          onClick={() => setAddressModal(true)}
        >
          <FontAwesomeIcon icon={faMapMarkerAlt} sx={{ marginRight: theme.spacing(1), fontSize: 25 }} />
          Revisa si llegamos a tu domicilio
        </Button>
      </Box>

      <Dialog open={addressModal} onClose={() => setAddressModal(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          Dirección
          <IconButton
            aria-label="close"
            onClick={() => setAddressModal(false)}
            sx={{ position: "absolute", right: 8, top: 8, color: theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <InputLocation setClientLocation={setClientLocation} />
          <AddressDisplay clientLocation={clientLocation} />
        </DialogContent>
      </Dialog>

      <Dialog open={isOpenModal} onClose={() => setIsOpenModal(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ textAlign: 'center' }}>AGREGAR PRODUCTO</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setIsOpenModal(false)}
          sx={{ position: 'absolute', right: 8, top: 8, color: theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <ProductModal
            product={selectedProduct}
            setOrder={setOrder}
            order={order}
            mode={modalMode}
            onClose={() => setIsOpenModal(false)}
          />
        </DialogContent>
      </Dialog>

      {catalog ? catalog.map((menu) => (
        <Box key={menu.name} sx={{ textAlign: 'center' }} px={isMobile ? 2 : 4}>
          <Typography variant={isMobile ? "h5" : "h4"} sx={{ fontWeight: 600, mb: 1 }}>
            {menu.desc}
          </Typography>
          <SvgIcon sx={{ width: "auto", height: theme.spacing(3), display: "block", mx: "auto", mb: 2 }} viewBox="0 0 297.49 22.68">
            <path d="M281,14a99.87,99.87,0,0,1-11.71-.71c4.05-.42,8.28-1.64,10.48-5-3.87-1.11-9.12,1.66-11.05,5h0c-3.76-.43-7.51-1-11.24-1.52,3.14-.85,6.09-2.4,7.39-4.56a12,12,0,0,0-10.76,4.09l-1.7-.22c-3.2-.4-6.44-.73-9.68-.87,3.19-1.45,6.06-3.71,6.94-6.87-3.22,0-8,3.33-8.94,6.81-1.6,0-3.2,0-4.79.09-6.11.38-12.15,1.68-18.25,2.26-4.58.43-8.8-.64-13.09-1.87-.23-2.3-1.52-4.56-4.34-6.43a21.35,21.35,0,0,0-19.51-1.85c-4.14,1.75-7.75,4.37-11.45,6.85a5.62,5.62,0,0,0,.34-5.22c-1.77-3.67-9.22-6-11.08-1.32-.19.49.47.75.8.47,2.14-1.86,6.33-.56,6.76,2.33.31,2.08-1.24,4.06-2.65,5.39-2,1.91-4.93,2.54-7.61,2.66a10,10,0,0,1-4.52-.86,3,3,0,0,1-1.77-1.73,5.24,5.24,0,0,0,0-1.48c.34-.91,1.26-1.4,1.94-.54.27.34.9,0,.74-.42-.54-1.31-1.53-1.94-2.89-1.32a2.72,2.72,0,0,0-.64.45,2.47,2.47,0,0,0-.63-.45c-1.36-.62-2.35,0-2.89,1.32-.16.4.47.76.73.42.69-.86,1.61-.37,2,.54a5.24,5.24,0,0,0,0,1.48,3.05,3.05,0,0,1-1.77,1.73,10,10,0,0,1-4.52.86c-2.68-.12-5.6-.75-7.62-2.66-1.41-1.33-2.95-3.31-2.64-5.39.43-2.89,4.62-4.19,6.76-2.33.33.28,1,0,.8-.47-1.86-4.7-9.31-2.35-11.08,1.32a5.62,5.62,0,0,0,.34,5.22c-3.7-2.48-7.31-5.1-11.46-6.85a21.33,21.33,0,0,0-19.5,1.85C94.4,6,93.11,8.29,92.88,10.59c-4.29,1.23-8.52,2.3-13.09,1.87-6.1-.58-12.14-1.88-18.25-2.26-1.59-.1-3.19-.12-4.79-.09C55.79,6.63,51,3.3,47.81,3.3c.88,3.16,3.75,5.42,6.94,6.87-3.24.14-6.48.47-9.68.87l-1.7.22A12,12,0,0,0,32.61,7.17c1.3,2.16,4.24,3.71,7.39,4.56-3.74.53-7.49,1.09-11.24,1.52h0c-1.93-3.31-7.18-6.08-11-5,2.2,3.4,6.43,4.62,10.48,5A99.87,99.87,0,0,1,16.46,14C11.77,11.52,5.22,10.08,0,11.32c4.47,5.26,11.69,4,17.85,3.88a86.66,86.66,0,0,0,14.32-.1c-3.82,1.3-10.1,4.36-10.34,7,4.42-.56,11.6-1.94,12.44-7.18,3.54-.33,7.1-.77,10.71-1.2-3.11,1.57-6,4.1-6.57,7,4.21,0,10-3.1,11.51-7.53a62.45,62.45,0,0,1,13.18-.11l1.78.23c-4.42.74-9.67,2.37-11.54,6.59,4.84,0,11-1.85,13.6-6.28,4.29.68,8.54,1.58,12.85,2.16a34.9,34.9,0,0,0,13.86-.84c2.88,6.55,12.81,11.28,17.78,4.3,1.47-2.07-2-4.15-3.43-2-3.39,5.19-10.77,2.1-12.52-2.81,5.2-1.57,10.39-2.87,15.88-2.73,7.69.19,15.31,2.24,23,3.17l.29.14c3.91,1.79,11.46,2.31,14.13-1.91,2.68,4.22,10.23,3.7,14.14,1.91l.29-.14c7.65-.93,15.27-3,23-3.17,5.49-.14,10.68,1.16,15.88,2.73-1.75,4.91-9.13,8-12.53,2.81-1.4-2.15-4.89-.07-3.42,2,5,7,14.9,2.25,17.78-4.3a34.89,34.89,0,0,0,13.86.84c4.31-.58,8.56-1.48,12.85-2.16,2.61,4.43,8.76,6.28,13.6,6.28C242.28,15.67,237,14,232.61,13.3l1.78-.23a62.45,62.45,0,0,1,13.18.11c1.55,4.43,7.29,7.53,11.5,7.53-.54-2.89-3.45-5.42-6.56-7,3.6.43,7.17.87,10.71,1.2.84,5.24,8,6.62,12.44,7.18-.24-2.64-6.52-5.7-10.35-7a86.67,86.67,0,0,0,14.32.1c6.17.13,13.39,1.38,17.86-3.88C292.27,10.08,285.72,11.52,281,14ZM111.36,8A50.16,50.16,0,0,0,95.65,9.8c2.22-5.12,9.4-8.61,14.76-8.15,7.09.59,12.28,5.37,18,9A88.33,88.33,0,0,0,111.36,8Zm74.77,0a88.08,88.08,0,0,0-17,2.73c5.7-3.66,10.88-8.44,18-9,5.36-.46,12.54,3,14.76,8.15A50.16,50.16,0,0,0,186.13,8Z" />
          </SvgIcon>

          <List sx={{ p: 0 }}>
            {menu.Products.filter(p => p.active).map(product => {
              const prices = product.Variants.filter(v => v.active).map(v => v.price);
              const hasImage = Boolean(product.Product_Images[0]?.publicUrl);
              const priceLabel = [...new Set(prices)].length > 1
                ? `$${addThousandsSeparator(Math.min(...prices))} – $${addThousandsSeparator(Math.max(...prices))}`
                : `$${addThousandsSeparator(prices[0])}`;

              return (
                <ListItem key={product.idProduct} disableGutters sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: 2,
                      p: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 2,
                      transition: 'box-shadow .2s',
                      '&:hover': { boxShadow: 3 },
                    }}
                  >
                    <ButtonBase
                      onClick={() => {
                        setSelectedProduct({ idProduct: product.idProduct });
                        setModalMode('display');
                        setIsOpenModal(true);
                      }}
                      sx={{
                        width: isMobile ? '100%' : 200,
                        height: isMobile ? 150 : 170,
                        borderRadius: 1,
                        overflow: 'hidden',
                        flexShrink: 0,
                      }}
                    >
                      {hasImage ? (
                        <Box
                          component="img"
                          src={product.Product_Images[0].publicUrl}
                          sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      ) : (
                        <LocalPizzaIcon sx={{ fontSize: 64, m: 'auto' }} />
                      )}
                    </ButtonBase>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: isMobile ? 18 : 22 }}>
                        {product.name}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5, fontSize: isMobile ? 14 : 16, color: 'text.secondary' }}>
                        {product.desc}
                      </Typography>

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: isMobile ? 16 : 20 }}>
                          {priceLabel}
                        </Typography>
                        <Button
                          variant="contained"
                          size="medium"
                          startIcon={<AddShoppingCartIcon />}
                          onClick={() => {
                            setSelectedProduct({ idProduct: product.idProduct });
                            setModalMode('cart');
                            setIsOpenModal(true);
                          }}
                          sx={{ textTransform: 'none', borderRadius: 1 }}
                        >
                          Agregar
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
              );
            })}
          </List>
        </Box>
      )) : <CircularProgress />}

      {order.Order_Items.length > 0 && (
        <Button
          sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2000 }}
          variant="contained"
          color="secondary"
          fullWidth
        >
          <Link to="/checkout" style={{
            color: "white",
            fontWeight: "bold",
            textDecoration: "none",
            width: "100%",
            padding: theme.spacing(1),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <Badge badgeContent={order.Order_Items.length} color="primary" sx={{ mr: 2 }}>
              <ShoppingCartIcon />
            </Badge>
            Ver Carrito
          </Link>
        </Button>
      )}
    </>
  );
};

export default Menu;
